<div class="content">

  <!--
      disablePictureInPicture controlsList="nodownload"

      controlsList="nodownload"
  -->
  <video #localVideo id="localVideo" webkit-playsinline="true" autoplay playsinline controls></video>


  <div class="buttonDiv">
    <button mat-raised-button aria-label="Povečaj" id="fullScreenBtn" (click)="fullScreen()">
      Povečaj
    </button>
  </div>

  <!--<video #remoteVideo id="remoteVideo" webkit-playsinline="true" autoplay playsinline controls></video>-->
  
</div>

<div style="display:none">
  <canvas #canvas id="takePhotoCanvas"></canvas>
</div>

